import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import parse from 'html-react-parser';
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceDetail from "../../../components/maintenance/detail/detail";
// Components
import FilesList from "../../../components/filesList/filesList";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as podcastsActions from "../../../redux/actions/podcasts";
// Utils
import { 
  formatDateToMadridTime, 
} from "../../../utils/formatters";
// Styles
import "./detail.css";

const PodcastsDetail = () => {
  const dispatch = useDispatch();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage); 
  const user = useSelector(state => state.authReducer.user);

  // Set constants
  const page = "podcasts";
  const primaryName = !!detail && !!detail.title ? detail.title : ``;
  const itemNameSingular = "Podcast";

  // Get id from url
  const { id: paramId } = useParams();
  const id = parseInt(paramId);
  // console.log('id', id);
  
  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
    // Set initial breadscrum
    const pathKey = 'detail';
    const path = `${page}/${pathKey}/${id}`;
    dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, itemNameSingular, }])); 
  }, []);

  const renderDetail = () => {
    // console.log('renderDetail > detail', detail);
    if (!detail) return null;
    return (
      <div className="podcasts-detail-cards-wrapper">
        {renderMainCard()}
        {renderFilesList()}
      </div>
    );
  };

  const renderMainCard = () => {
    const url_web = !!detail.url_web ? parse(`<a href="${detail.url_web}" target="_blank">${detail.url_web}</a>`) : "";
    
    return (
      <div className="maintenance-detail-card podcasts-detail-card">
        <div className="title maintenance-detail-title">
          {detail.title}
        </div>
        {renderField("Id", detail.id)}
        {renderField("Habilitat", detail.enabled ? "SI" : "NO")}   
        {renderField("Títol", detail.title)}
        {renderField("Descripció", detail.description)}
        {renderField("Grup", detail.podcasts_group_title)}
        {renderField("Data", formatDateToMadridTime(detail.date, true))} 
        {renderField("Prioritat", detail.priority)}  
        {renderField("Títol de l'audio", detail.text_audio)}    
          {renderField("Url Web", url_web)}
        <Box h={"20px"}></Box>            
        {renderField("Data de creació", formatDateToMadridTime(detail.creation_date))}
        {renderField("Usuari de creació", detail.creation_user)}
        {renderField("Data última modificació", formatDateToMadridTime(detail.last_modification_date))}
        {renderField("Usuari última modificació", detail.last_modification_user)}
      </div>
    );
  };

  const renderFilesList = () => {
    const url_audio_1 = !!detail.url_audio_1 ? parse(`<a href="${detail.url_audio_1}" target="_blank">${detail.url_audio_1}</a>`) : "";
    const url_image_1 = !!detail.url_image_1 ? parse(`<a href="${detail.url_image_1}" target="_blank">${detail.url_image_1}</a>`) : "";

    return (
      <div className="maintenance-detail-filelist-card">
        <Box className="maintenance-detail-label">
          Fitxer d'audio
        </Box>
        {!!url_audio_1 && (
          <Box mt="3px" className="maintenance-detail-field">
            {url_audio_1}
          </Box>       
        )}           
        <FilesList
          type={"podcasts"}
          id={id}
          id2={"1"}
          setIsLoading={setIsLoading}
          label={""}
        />

        <Box className="maintenance-detail-label">
          Imatge
        </Box>
        {!!url_image_1 && (
          <Box mt="3px" className="maintenance-detail-field">
            {url_image_1}
          </Box>       
        )}             
        <FilesList
          type={"podcasts"}
          id={id}
          id2={"2"}
          setIsLoading={setIsLoading}
          label={""}
        />        
      </div>
    );
  };

  const renderField = (label, value) => {
    return (
      <div className="maintenance-detail-field-parent">
        <Box className="maintenance-detail-label" w={"220px"}>
          {label}
        </Box>    
        <Box className="maintenance-detail-field">
          {value}
        </Box>         
      </div>
    );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="podcasts-detail-content">
        <MaintenanceDetail 
          primaryValue={id}
          primaryName={primaryName}
          menuConfig={{
            buttonEdit: { visible: !!user && user.grants.podcasts },
            buttonDelete: { visible: !!user && user.grants.podcasts },
          }}
          itemNameSingular={itemNameSingular}
          itemIsMale={true}
          actions={podcastsActions} 
          setIsLoading={setIsLoading}
          renderDetail={renderDetail}
          setDetail={setDetail}
          page={"podcasts"}
        />
      </div>
    </MainLayout>
  );
};

export default PodcastsDetail;
